<div class="">
    <span class="d-print-none">

    <!-- <a class="btn ml-2" [routerLink]="['/Login']">
      <mat-icon *ngIf="!user">login</mat-icon>
    </a>
    <a class="btn btn-outline-primary ml-2" [routerLink]="['/dashboard']" routerLinkActive="router-link-active">
      <mat-icon> dashboard </mat-icon>
    </a>
    <a class="btn btn-outline-success ml-2" [routerLink]="['/Nagotiation']" routerLinkActive="router-link-active">
      <mat-icon class="text-success">attach_money</mat-icon>
    </a>

    <a class="btn btn-outline-secondary ml-2" [routerLink]="['/AssignContact']" routerLinkActive="router-link-active">
      <mat-icon class="text-success">import_contacts</mat-icon>
    </a>
    <a class="btn btn-outline-secondary ml-2" [routerLink]="['/DatMua']" routerLinkActive="router-link-active">
      <mat-icon matTooltip='những người đã đặt hàng hoặc gửi câu hỏi' class="text-success">add_shopping_cart</mat-icon>
    </a>
    <a class="btn btn-outline-secondary ml-2" [routerLink]="['/MarketingReport']" routerLinkActive="router-link-active">
      <mat-icon matTooltip='Cáo cáo cho marketing hàng ngày sale thực hiện kiểm tra' class="text-success">insights
      </mat-icon>
    </a>
    <a class="btn btn-outline-secondary ml-2" [routerLink]="['/EmailAnalytic']" routerLinkActive="router-link-active">
      <mat-icon matTooltip='Phân tích người click vào email. Sale cần thực hiện hàng ngày để biết khách hàng tiềm năng'
        class="text-success">email</mat-icon>
    </a>


    <a class="btn btn-outline-secondary ml-2" [routerLink]="['/SubizAnalytic']" routerLinkActive="router-link-active">
      <mat-icon
        matTooltip="Những người tiềm năng đã truy cập website  Sale cần kiểm tra hàng ngày để tìm được khách hàng  "
        class="text-success">chat</mat-icon>
    </a>
    <a class="btn btn-outline-secondary ml-2" [routerLink]="['/UserReport']" routerLinkActive="router-link-active">
      <mat-icon
        matTooltip="Những người tiềm năng đã truy cập website  Sale cần kiểm tra hàng ngày để tìm được khách hàng  "
        class="text-success">report</mat-icon>
    </a>

    <a class="btn btn-outline-secondary ml-2" [routerLink]="['/SaleReport']" routerLinkActive="router-link-active">
      <mat-icon matTooltip="Báo cáo của sale " class="text-success"><span class="material-icons-outlined">
          report_problem
        </span></mat-icon>
    </a>
    <a class="btn btn-outline-secondary ml-2" [routerLink]="['/CallDetail']" routerLinkActive="router-link-active">
        <mat-icon matTooltip="Báo cáo của sale " class="text-success"><span class="material-icons-outlined">
          settings_phone
        </span></mat-icon>
    </a>
    <a class="btn btn-outline-secondary ml-2" [routerLink]="['/CallTran']" routerLinkActive="router-link-active">
        <mat-icon matTooltip="Báo cáo của sale " class="text-success"><span class="material-icons-outlined">
          phone
        </span></mat-icon>
    </a>
    <a class="btn btn-outline-secondary ml-2" [routerLink]="['/KTTD']" routerLinkActive="router-link-active">
        <mat-icon matTooltip="Danh sách người kiểm tra trình độ" class="text-success"><span class="material-icons-outlined">
          quiz
        </span></mat-icon>
    </a>
    </span> -->
    <!-- <h1>User: {{ user.user.name }}</h1> -->
    <app-header></app-header>
    </span>
    <router-outlet #outlet="outlet"></router-outlet>
</div>